export const DEFAULT_ASSISTANT_NAME = "Bizly Router";
export const MAX_ASSISTANT_NAME_LENGTH = 40;
export const ASSISTANT_NAME_ONBOARDING_STEP = 8;

export function normalizeAssistantName(value?: string | null): string {
  const normalized = typeof value === "string" ? value.trim() : "";
  return !normalized || normalized.toLowerCase() === "bonni" ? DEFAULT_ASSISTANT_NAME : normalized;
}

export function hasConfiguredAssistantName(value?: string | null): boolean {
  return typeof value === "string" && value.trim().length > 0;
}

export function getOwnerOnboardingSteps(assistantName?: string | null): number[] {
  const standardSteps = [2, 3, 4, 5, 6, 7];
  if (hasConfiguredAssistantName(assistantName)) return standardSteps;

  return [2, ASSISTANT_NAME_ONBOARDING_STEP, ...standardSteps.slice(1)];
}
